import Projects from "../components/sections/Projects";

export default function ProjectsPage() {
  return (
    <div className="pt-10">
      <Projects />
    </div>
  );
}